import { RootState } from '../../store/rootReducer';

export const RenewalCreditSelector = (state: RootState) => state.renewalCreditOptions;
export const RenewalLeasingSelector = (state: RootState) => state.renewalLeasingOptions;
export const RenewalPremiumCreditSelector = (state: RootState) => state.renewalPremiumCreditOptions;
export const PremiumCreditInfoModalStepsSelector = (state: RootState) => state.premiumCreditInfoModalSteps;
